module.exports = __webpack_public_path__ + "img/isolation.6dbd2413.png";